'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Option;

var _react = require('react');

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function Option(props) {
  return React.createElement(
    'div',
    null,
    props.children
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/select/option.js
// module id = 350
// module chunks = 114276838955818